import ensureGoogleAnalytics from '../ensureGoogleAnalytics.js';
import { pageDataTransformer, inventoryTransformer } from '../../../transformers/google/index.js';
const getBusinessUnit = brand => {
  let value = '';
  switch (brand) {
    case 'atc':
      value = 'autotrader';
      break;
    case 'kbb':
      value = 'Kelley Blue Book';
      break;
    case 'ford':
      value = 'fordblueadvantage';
      break;
    default:
  }
  return value;
};
export default async function sendPageDataEvent(metadata, options) {
  if (metadata === void 0) {
    metadata = {};
  }
  if (options === void 0) {
    options = {};
  }
  const {
    dataLayer = {},
    history,
    dataIsland = {}
  } = metadata;
  const {
    siteSection = '',
    pageType = '',
    detailPageName = ''
  } = dataLayer.page || {};
  const errorPage = dataIsland?.page?.BIRF?.pg === 'error';
  const pageData = {
    event: 'page_data',
    common: {
      // Populated from the Common Data Layer.
      // Default value of 0 to ensure all hits report back a data layer version.
      // 0 indicates that an application or page has not yet implemented the Common Data Layer
      dataLayerVersion: '1',
      application: {
        // Populated from the Common Data Layer based on an expected list of values to separate KBB from AT in a rollup report.
        businessUnit: getBusinessUnit(dataLayer.brand || dataLayer.catalog),
        name: dataLayer.application?.name,
        version: dataLayer.application?.version,
        environment: dataLayer.application?.environment
      },
      user: {
        adBlockerState: dataLayer.user?.adBlockerState,
        isLoggedIn: dataLayer.user?.isLoggedIn?.toString(),
        isInternalUser: 'false',
        // This flag comes from MOAT and is used to store into User-Behavior data when MOAT detects user as NHT.
        // Implementation may not be complete (only 1 update per visit, instead of on every page). e.g.: 0 or 1
        ivtMoatFlag: dataLayer.user?.ivtMoatFlag,
        zipCode: dataLayer.user?.zipCode
      },
      page: {
        siteSection: errorPage ? 'error' : siteSection,
        detailPageName: errorPage ? dataIsland?.page?.BIRF?.pg_id : detailPageName,
        pageType: errorPage ? 'error' : pageType,
        // A/B test platform experiment id, array of all feature/variations a user gets bucketed into
        experimentId: dataLayer.page?.experimentId,
        pixAllPXAId: dataLayer.page?.pixallId,
        pixAllABC: dataLayer.page?.pixallABC,
        pixallPageInstanceId: dataLayer.page?.pixallPageInstanceId
      }
    },
    search: {
      catalog: dataLayer.catalog,
      pagination: dataLayer.search?.pagination?.toString(),
      sortType: dataLayer.search?.sortType,
      ...pageDataTransformer(dataLayer?.search?.filters)
    }
  };

  // Only for pages where PE data is available
  if (dataLayer.consumerInsights) {
    pageData.consumerInsights = dataLayer.consumerInsights;
  }
  if (dataLayer.consumerAdTargets) {
    pageData.consumerAdTargets = dataLayer.consumerAdTargets;
  }
  if (dataLayer.consumerAdTargetsWithoutCAMPBias) {
    pageData.consumerAdTargetsWithoutCAMPBias = dataLayer.consumerAdTargetsWithoutCAMPBias;
  }
  if (dataLayer.consumerMarketingSegments) {
    pageData.consumerMarketingSegments = dataLayer.consumerMarketingSegments;
  }

  // for single vehicle pages (list pages are handled through impression tracking)
  if (dataLayer.vehicle) {
    pageData.vehicle = {
      catalog: dataLayer.catalog,
      clickType: dataLayer.vehicle?.clickType,
      ...inventoryTransformer(dataLayer?.vehicle, {
        target: 'pageData'
      })
    };
  } else {
    pageData.vehicle = undefined;
  }
  await ensureGoogleAnalytics(options, googleDataLayer => {
    googleDataLayer.push(pageData);
  }, {
    history,
    isPageEvent: true
  });
}